/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


(function($) {
  var mainNav, subnav, headerHeight, activeSubNavItem, stickyTrigger, pos, prevpos, jobs, menu, isHome, isMobile, profiles;

  var resizeSetters = function(){
    // var activeBio = $('.bio.active');
    // if ( window.innerWidth <= 980 && activeBio.length > 0 ) {
    //   closeBio( activeBio );
    // }
  };

  function getInsertIndex (index, length) {
    while (index % 4 != 3 && index < length -1) {
      index++
    }
    return index
  }

  var scrollToPosition = function(position){
    //get fixed header height
    var hh = $('header.header').height();

    TweenMax.to(window, 1, {
      scrollTo: {
        y: position - (hh || 0)
      },
      ease:Power2.easeInOut
    });
  };

  function scrollToTarget (target) {
      $('html, body').animate({
          scrollTop: target.offset().top
      }, 1000);
  }

  function toggleIndicator (currentTarget, newTarget) {
      currentTarget.removeClass('current');
      newTarget.addClass('current');
  }

  function updateIndicator () {
    var dotNav = $('.dot-nav');
    var dotLength = $('.js-dotstyle-item')

    dotNav.each(function (i) {
        $this = $(this);

        var currentIndicator = $('.js-dotstyle-item.current')
        var newIndcator = $('a[href="#'+ $this.attr('id') +'"]');

        if ( ( $this.offset().top - $(window).height()/2 < $(window).scrollTop() ) && ( $this.offset().top + $this.height() - $(window).height()/2 > $(window).scrollTop() ) ) {
            toggleIndicator(
                $('.js-dotstyle-item.current'),
                $('a[href="#'+ $this.attr('id') +'"]')
            )
        }
    })
  }

  function closeAccordianItem ( item ) {
    TweenMax.to(item, 1, { height: "2.6rem"})
  }

  function openAccordianItem ( item ) {
    TweenMax.set(item, {height: "auto"})
    TweenMax.from(item, 1, { height: "2.6rem" })
  }

  var addAccordiantListener = function() {
    var jsTogglePost = $('.js-toggle-post')
    jsTogglePost.off('click');
    jsTogglePost.on('click', function(e){
      e.preventDefault();

      var currentId, thisElement, postTitle, postExcerpt, openPost;

      thisElement = $(this);
      currentId = thisElement.attr('href');
      postTitle = thisElement.find('.post-title');
      postExcerpt = thisElement.find('.post-excerpt');

      if ( !thisElement.closest('.js-toggle-post').hasClass('closed') ) {
        closeAccordianItem( postTitle );
        closeAccordianItem( postExcerpt );
        thisElement.addClass('closed');
      } else {
        openAccordianItem( postTitle );
        openAccordianItem( postExcerpt );
        thisElement.removeClass('closed');
      }
    })
  }

  function loadMoreItems (href) {
    $.get(href, function(response) {
      var initialResponse = $(response);

      var results = initialResponse.find('.post');
      var newHref = initialResponse.find('.js-load-more').attr('href');
      $('.js-for-pagination').remove();

      $.each(results, function(index, el){
        $(el).addClass('new-tile')
      })

      $('.posts').append(results);

      TweenMax.fromTo($('.new-tile'), .3, {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0
      });

      setTimeout(function(){
        $('.new-tile').removeClass('new-tile')
      }, 300);

      //addAccordiantListener();
      //addPaginationListener();
    })
  }

  /*
  var addPaginationListener = function() {
    $('.js-load-more').on('click', function (e){
      e.preventDefault();

      $(e.currentTarget).text('Loading . . .');

      var href = $(e.currentTarget).attr('href');
      loadMoreItems(href);
    })
  }
  */

  // Open Bio
  var bioBurgerTimeout;
  var $companies = $('#companies');

  function openBio ( id, insertIndex ) {
    var bio = $('.bio#' + id)
    var offset = $('#' + id).offset();
    if(!offset) return false;

    bio.addClass('active');
    $companies.addClass('bio-open');

    $('.ind-profile').eq(insertIndex).after(bio);
    scrollToPosition($('#' + id).offset().top);

    bioBurgerTimeout = window.setTimeout(function() {
      $('.js-close-bio').addClass('active');
    }, 1000)

  }

  // Close Bio
  function closeBio ( activeBio ) {
    activeBio.removeClass('active');
    $companies.removeClass('bio-open');

    $('.profile[data-name="' + activeBio.attr('id') +  '"]').after(activeBio);
    scrollToPosition($('#team').offset().top);
    $('.js-close-bio').removeClass('active');
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Arrow in Hero to next section
        $('.js-next-section').on('click', function(e) {
          e.preventDefault();
          scrollToPosition($('.page-content').children().first().offset().top);
          return false;
        })

        // Toggle mobile nav
        $('.js-mobile-nav-toggle, .menu-item').on('click', function(){
          $('.js-mobile-nav-toggle').toggleClass('active');
          var $nav = $('.js-main-nav');
          $nav.toggleClass('active');
          var isActive = $nav.hasClass('active');
          if(isActive) {
            $nav.css('display', 'flex');
            $nav.css('opacity', 0);
            $nav.stop().animate({ opacity: 1 });
          } else {
            $nav.css('opacity', 1);
            $nav.stop().animate({ opacity: 0 }, function() {
              $nav.css('display', 'none');
              $nav.css('opacity', 0);
            });
          }
        })

        // Toggle bios
        $('.js-bio-toggle, .js-close-bio').on('click', function(e) {
          e.preventDefault();
          var profId, activeBio, profileIndex, profileLength, insertIndex;

          profId = $(e.target).data('name') || $(e.target).parent().data('name');
          activeBio = $('.bio.active');

          profileIndex = $('.ind-profile').index( this );
          profileLength = $('.ind-profile').length;
          insertIndex = getInsertIndex( profileIndex, profileLength );

          if ( activeBio.length >= 1 && activeBio.attr('id') === profId ) {
            closeBio( activeBio );
          } else if ( activeBio.length >= 1 && activeBio.attr('id') !== profId ) {
            closeBio( activeBio );
            openBio( profId, insertIndex );
          } else {
            openBio( profId, insertIndex );
          }

          return false;
        })

        /*
        // Dot list nav
        $('.js-dotstyle-item').on('click', function (e) {
            e.preventDefault();

            toggleIndicator(
                $('.js-dotstyle-item.current'),
                $(e.target)
            );

            scrollToTarget(
                $( $(this).attr('href') )
            );
        })
        */

        // Posts Accordian
        //addAccordiantListener();

        $(window).on('resize', function(){
          resizeSetters();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
